<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/K5oiA6/tc-custom/9781401686307.jpg?1728954633219" alt="This image is the cover for the book Eyes of Justice, The Triple Threat Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Eyes of Justice, The Triple Threat Novels
      </h1>
      <p class="bookDescription body article font2">
        <p><b>When One of the Triple Threat Is Murdered, All Eyes Turn to Justice.</b></p><p>Cassidy, Allison, and Nicole fight for justice everyday—Cassidy as a crime reporter, Nicole as an FBI agent, and Allison as a federal prosecutor. Together they’re a Triple Threat to be reckoned with. A force that, together, has solved the toughest mysteries.</p><p>Until a ruthless killer finds a way to isolate and murder one of the three.</p><p>When the authorities keep the survivors at arm’s length in the investigation, the women’s desire for justice goes into overdrive. They find an unexpected ally in a quirky private investigator named Ophelia whose unorthodox methods seem to offer a possible breakthrough in the case.</p><p>Yet just as the police appear to have the killer in custody and justice within sight, the murderer strikes again. Not knowing whom to trust, the team must engage in a deadly game of cat-and-mouse where nothing can be taken at face value . . . and nothing will ever be the same.</p><p>A riveting Triple Threat mystery that will leave readers shocked and satisfied.</p><p>“[S]hocking, fast-paced . . . For those seeking gal pal tales reminiscent of Tess Gerritsen’s Jane Rizzoli and Maura Isles, the Triple Threat adventures are a sure bet.” —<i>Publishers Weekly</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lis Wiehl, April Henry
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?07d45c7e